var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZeros(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.25C0 7.54688 3 4.5 6.75 4.5C10.4531 4.5 13.5 7.54688 13.5 11.25V18.75C13.5 22.5 10.4531 25.5 6.75 25.5C3 25.5 0 22.5 0 18.75V11.25ZM6.75 7.5C4.64062 7.5 3 9.1875 3 11.25V18.75C3 20.8594 4.64062 22.5 6.75 22.5C8.8125 22.5 10.5 20.8594 10.5 18.75V11.25C10.5 9.1875 8.8125 7.5 6.75 7.5Z",
    fill: "#465DD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.5 11.25C16.5 7.54688 19.5 4.5 23.25 4.5C26.9531 4.5 30 7.54688 30 11.25V18.75C30 22.5 26.9531 25.5 23.25 25.5C19.5 25.5 16.5 22.5 16.5 18.75V11.25ZM23.25 7.5C21.1406 7.5 19.5 9.1875 19.5 11.25V18.75C19.5 20.8594 21.1406 22.5 23.25 22.5C25.3125 22.5 27 20.8594 27 18.75V11.25C27 9.1875 25.3125 7.5 23.25 7.5Z",
    fill: "#465DD8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeros);
export default __webpack_public_path__ + "static/media/zeros.e5e3b800.svg";
export { ForwardRef as ReactComponent };